/** Sample data aligned with LittleNest Baby-shop seed & homepage structure (UI-only). */

/** Header “Shop by Brands” dropdown (matches seed brand names). */
export const DEMO_BRANDS = [
  { id: "b1", name: "LittleNest", slug: "littlenest" },
  { id: "b2", name: "Pampers", slug: "pampers" },
  { id: "b3", name: "MamyPoko", slug: "mamypoko" },
  { id: "b4", name: "Sweety", slug: "sweety" },
  { id: "b5", name: "Pigeon", slug: "pigeon" },
  { id: "b6", name: "Johnsons", slug: "johnsons" },
  { id: "b7", name: "Philips Avent", slug: "philips-avent" },
];

export const SHOP_HERO_SLIDES = [
  {
    id: "h1",
    badge: "Pilihan Terbaik",
    title: "Kebutuhan pokok si kecil, satu tempat.",
    subtitle: "Popok, nutrisi, higiene, tidur, dan gear — terkurasi untuk orang tua sibuk.",
    imageUrl: "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=1400&h=900&fit=crop",
  },
  {
    id: "h2",
    badge: "Promo",
    title: "Bundling hemat untuk bulan pertama",
    subtitle: "Kombinasi popok, wipes, dan skincare lembut untuk kulit newborn.",
    imageUrl: "https://images.unsplash.com/photo-1584534981383-ecf73c2d66b4?w=1400&h=900&fit=crop",
  },
  {
    id: "h3",
    badge: "Edukasi",
    title: "Mainan aman yang mendukung tumbuh kembang",
    subtitle: "Teether, buku kontras, dan puzzle kayu — tanpa BPA.",
    imageUrl: "https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=1400&h=900&fit=crop",
  },
];

export const SHOP_TRUST_HIGHLIGHTS = [
  { title: "Fokus kebutuhan anak", desc: "Katalog mengutamakan barang pokok yang sering dipakai sehari-hari." },
  { title: "Kirim cepat", desc: "Pilihan kurir fleksibel dan estimasi transparan." },
  { title: "Kemasan aman", desc: "Perlindungan ekstra untuk produk sensitif." },
  { title: "Customer care", desc: "Dukungan belanja cepat dan responsif." },
];

/** Same gradient tones as Baby-shop `categoryCards` + filter key for demo catalog */
export const SHOP_CATEGORY_CARDS = [
  { label: "Popok & wipes", hint: "Kebutuhan ganti popok harian", tone: "from-[#fff2e2] to-[#ffe9cd]", filter: "diapers" },
  { label: "Makan & nutrisi", hint: "Botol, mpasi, camilan sehat", tone: "from-[#ecf9f5] to-[#d9f3ec]", filter: "feeding" },
  { label: "Mandi & higiene", hint: "Shampoo, lotion, perawatan kulit", tone: "from-[#eef6ff] to-[#dcecff]", filter: "bath" },
  { label: "Pakaian dasar", hint: "Bodysuit, kaus kaki, perlengkapan sekolah", tone: "from-[#fff3f4] to-[#ffe7ea]", filter: "clothing" },
  { label: "Tidur & nursery", hint: "Sprei, sleeping bag, lampu malam", tone: "from-[#f5f0ff] to-[#e8e0ff]", filter: "sleep" },
  { label: "Mainan & belajar", hint: "Teether, buku, puzzle edukatif", tone: "from-[#fff8e8] to-[#ffefce]", filter: "toys" },
  { label: "Kesehatan & keamanan", hint: "Termometer, pengaman rumah", tone: "from-[#e8fff4] to-[#d4f5e8]", filter: "health" },
  { label: "Gear & travel", hint: "Stroller, gendongan, tas popok", tone: "from-[#f1f4ff] to-[#e4ebff]", filter: "gear" },
];

export const SHOP_VOUCHERS = [
  { id: "v1", code: "WELCOME10", type: "PERCENT", value: 10, minSubtotal: 80000 },
  { id: "v2", code: "FREESHIP", type: "FIXED", value: 15000, minSubtotal: 120000 },
  { id: "v3", code: "SAVEMORE", type: "PERCENT", value: 15, minSubtotal: 200000 },
];

export const SHOP_QUICK_LINKS = [
  { title: "Belanja Cepat", desc: "Temukan kebutuhan harian" },
  { title: "Voucher Aktif", desc: "Promo terbaik setiap minggu" },
  { title: "Checkout Mudah", desc: "Pembayaran lebih ringkas" },
  { title: "Lacak Pesanan", desc: "Pantau status secara realtime" },
];

export const SHOP_PRODUCTS = [
  {
    id: "1",
    category: "diapers",
    brand: "LittleNest",
    name: "Popok newborn NB — 20 pcs",
    price: 52000,
    salePrice: null,
    stock: 24,
    ratingAvg: 4.7,
    ratingCount: 128,
    image: "https://images.unsplash.com/photo-1584534981383-ecf73c2d66b4?w=600&h=600&fit=crop",
  },
  {
    id: "2",
    category: "diapers",
    brand: "MamyPoko",
    name: "Popok celana ukuran M — 32 pcs",
    price: 78000,
    salePrice: 69000,
    stock: 40,
    ratingAvg: 4.8,
    ratingCount: 256,
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&h=600&fit=crop",
  },
  {
    id: "3",
    category: "feeding",
    brand: "Pigeon",
    name: "Botol wide-neck 160 ml",
    price: 65000,
    salePrice: null,
    stock: 18,
    ratingAvg: 4.6,
    ratingCount: 89,
    image: "https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=600&h=600&fit=crop",
  },
  {
    id: "4",
    category: "feeding",
    brand: "Philips Avent",
    name: "Set sendok bayi lembut — 5 pcs",
    price: 35000,
    salePrice: null,
    stock: 32,
    ratingAvg: 4.4,
    ratingCount: 54,
    image: "https://images.unsplash.com/photo-1620706857370-e1b9770e8bb1?w=600&h=600&fit=crop",
  },
  {
    id: "5",
    category: "bath",
    brand: "Johnsons",
    name: "Shampoo bayi no tears — 200 ml",
    price: 42000,
    salePrice: null,
    stock: 60,
    ratingAvg: 4.5,
    ratingCount: 201,
    image: "https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=600&h=600&fit=crop",
  },
  {
    id: "6",
    category: "bath",
    brand: "LittleNest",
    name: "Handuk hooded katun",
    price: 125000,
    salePrice: 108000,
    stock: 14,
    ratingAvg: 4.9,
    ratingCount: 67,
    image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&h=600&fit=crop",
  },
  {
    id: "7",
    category: "clothing",
    brand: "LittleNest",
    name: "Bodysuit lengan pendek — 3 pack",
    price: 145000,
    salePrice: null,
    stock: 22,
    ratingAvg: 4.6,
    ratingCount: 44,
    image: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=600&h=600&fit=crop",
  },
  {
    id: "8",
    category: "clothing",
    brand: "LittleNest",
    name: "Kaos kaki anti slip — 6 pasang",
    price: 75000,
    salePrice: null,
    stock: 0,
    ratingAvg: 4.3,
    ratingCount: 31,
    image: "https://images.unsplash.com/photo-1588097281266-300ce6a99bc6?w=600&h=600&fit=crop",
  },
  {
    id: "9",
    category: "sleep",
    brand: "LittleNest",
    name: "Sleeping bag wearable 1.0 TOG",
    price: 225000,
    salePrice: null,
    stock: 9,
    ratingAvg: 4.8,
    ratingCount: 112,
    image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?w=600&h=600&fit=crop",
  },
  {
    id: "10",
    category: "sleep",
    brand: "LittleNest",
    name: "Lampu malam LED hangat",
    price: 89000,
    salePrice: 79000,
    stock: 28,
    ratingAvg: 4.5,
    ratingCount: 76,
    image: "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?w=600&h=600&fit=crop",
  },
  {
    id: "11",
    category: "health",
    brand: "LittleNest",
    name: "Termometer digital telinga & dahi",
    price: 285000,
    salePrice: null,
    stock: 11,
    ratingAvg: 4.7,
    ratingCount: 93,
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=600&h=600&fit=crop",
  },
  {
    id: "12",
    category: "toys",
    brand: "LittleNest",
    name: "Teether silikon tekstur",
    price: 42000,
    salePrice: null,
    stock: 45,
    ratingAvg: 4.6,
    ratingCount: 58,
    image: "https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=600&h=600&fit=crop",
  },
  {
    id: "13",
    category: "toys",
    brand: "LittleNest",
    name: "Buku kain bayi kontras tinggi",
    price: 65000,
    salePrice: null,
    stock: 33,
    ratingAvg: 4.8,
    ratingCount: 41,
    image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=600&h=600&fit=crop",
  },
  {
    id: "14",
    category: "gear",
    brand: "LittleNest",
    name: "Stroller ringan lipat",
    price: 1850000,
    salePrice: null,
    stock: 4,
    ratingAvg: 4.9,
    ratingCount: 167,
    image: "https://images.unsplash.com/photo-1524985069686-c4bf2d022fdf?w=600&h=600&fit=crop",
  },
  {
    id: "15",
    category: "gear",
    brand: "LittleNest",
    name: "Tas popok backpack insulated",
    price: 295000,
    salePrice: 259000,
    stock: 16,
    ratingAvg: 4.7,
    ratingCount: 88,
    image: "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=600&h=600&fit=crop",
  },
];
